'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { omit, debounce } from '../../../utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import UpgradeProductProperties from 'self-service-api/constants/UpgradeProductProperties';
import { upgradeDataPropsInterface } from 'ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import { TrialActivationButtonPropsInterface } from 'ui-addon-upgrades/_core/trial/TrialPropsInterface';
import AdminOnlyWrapper from 'ui-addon-upgrades/_core/common/components/AdminOnlyWrapper';
import { TEAM } from 'ui-addon-upgrades/_core/common/constants/AdminTypes';
import { REQUEST_TRIAL, REQUEST_REMOTE_TOOLS } from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import TrialActivationModalContainer from './TrialActivationModalContainer';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIButton from 'UIComponents/button/UIButton';
import { TEMPORARY_REMOTE_TOOLS } from 'self-service-api/constants/UpgradeProducts';
var CLICK_DELAY = 50;

function sequence() {
  for (var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++) {
    handlers[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    handlers.forEach(function (handler) {
      return handler && handler.apply(void 0, args);
    });
  };
}

var TrialActivationButton = /*#__PURE__*/function (_Component) {
  _inherits(TrialActivationButton, _Component);

  function TrialActivationButton() {
    var _this;

    _classCallCheck(this, TrialActivationButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TrialActivationButton).call(this));

    _this.handleClick = function () {
      var upgradeData = _this.props.upgradeData;
      tracker.track('trialActivationButtonInteraction', Object.assign({
        action: 'clicked'
      }, upgradeData));

      _this.setState({
        showActivationModalContainer: true
      });
    };

    _this.state = {
      showActivationModalContainer: false
    };
    _this.debouncedHandleClick = debounce(_this.handleClick, CLICK_DELAY);
    return _this;
  }

  _createClass(TrialActivationButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var upgradeData = this.props.upgradeData;
      tracker.track('trialActivationButtonInteraction', Object.assign({
        action: 'viewed'
      }, upgradeData));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          hideBackground = _this$props.hideBackground,
          _this$props$upgradeDa = _this$props.upgradeData,
          trialId = _this$props$upgradeDa.trialId,
          upgradeProduct = _this$props$upgradeDa.upgradeProduct,
          upgradeData = _this$props.upgradeData,
          onClick = _this$props.onClick,
          onSuccess = _this$props.onSuccess,
          shouldHideSurvey = _this$props.shouldHideSurvey,
          successModalHeader = _this$props.successModalHeader,
          successModalSubText = _this$props.successModalSubText,
          successModalCtaText = _this$props.successModalCtaText,
          showSuccessModalIllustration = _this$props.showSuccessModalIllustration;
      var showActivationModalContainer = this.state.showActivationModalContainer;
      var onClickSequence = sequence(this.debouncedHandleClick, onClick);
      var propsToPass = omit(this.props, ['onClick', 'upgradeData', 'onSuccess', 'shouldHideSurvey', 'trialId', 'allowModal', 'successModalHeader', 'successModalSubText', 'successModalCtaText', 'showSuccessModalIllustration']);
      if (!trialId) return null;
      return React.createElement(React.Fragment, null, showActivationModalContainer && React.createElement(TrialActivationModalContainer, {
        hideBackground: hideBackground,
        upgradeData: upgradeData,
        shouldHideSurvey: shouldHideSurvey,
        onSuccess: onSuccess,
        successModalHeader: successModalHeader,
        successModalSubText: successModalSubText,
        successModalCtaText: successModalCtaText,
        showSuccessModalIllustration: showSuccessModalIllustration
      }), React.createElement(AdminOnlyWrapper, {
        adminType: TEAM,
        modalType: upgradeProduct === TEMPORARY_REMOTE_TOOLS ? REQUEST_REMOTE_TOOLS : REQUEST_TRIAL,
        merchandiseId: UpgradeProductProperties[upgradeProduct].merchandiseId
      }, propsToPass.use && propsToPass.use.includes('link') ? React.createElement(UIButton, Object.assign({}, propsToPass, {
        onClick: onClickSequence,
        "data-selenium": "trial-button",
        "data-reagan-primary-cta": true
      }), React.createElement(FormattedMessage, {
        message: "upgrades.trialActivationButton." + upgradeProduct
      })) : React.createElement(UILoadingButton, Object.assign({}, propsToPass, {
        onClick: onClickSequence,
        "data-selenium": "trial-button",
        "data-reagan-primary-cta": true,
        loading: showActivationModalContainer
      }), React.createElement(FormattedMessage, {
        message: "upgrades.trialActivationButton." + upgradeProduct
      }))));
    }
  }]);

  return TrialActivationButton;
}(Component);

TrialActivationButton.defaultProps = {
  use: 'primary',
  onClick: function onClick() {}
};
TrialActivationButton.propTypes = Object.assign({}, upgradeDataPropsInterface, {}, TrialActivationButtonPropsInterface, {
  onClick: PropTypes.func
});
export default TrialActivationButton;